export default __webpack_public_path__ + "locales/de/ConvertDialog.json?hash=b5e79f7459fe48db8e3a1aba79b3a0ac";